import { Request, post, withUrl } from '@factorin/rest';


export interface ConfirmationCodeRequest {
    email: string;
}

export interface FeedbackRequest {
    ConfirmationCode: string;
    Role: 1 | 2;
    Name: string;
    Email: string;
    INN: string;
    PlacementAmount?: number;
    ProfitabilityRate?: number;
    AttractionAmount?: number;
    AttractionAmountCost?: number;
    InvestorType?: 1 | 2 | 3;
    InvestorStatus?: 1 | 2;
}

const feedbackPart = withUrl('Feedback');

export const feedback = {
    sendCode: post<Request.Body<ConfirmationCodeRequest>, void>(({ body }) => feedbackPart({
        path: 'ConfirmationCode',
        body,
    })),
    sendForm: post<Request.Body<FeedbackRequest>, void>(({ body }) => feedbackPart({
        body,
    })),
};
